@if (!selectedPayment) {
  <gc-note-banner
    [noteText]="'your_bank_statement_will_display_GoodX_as_the_reference_for_this_payment'"
    [noteTitle]="'please_note'"
    [noteIcon]="'warning'"
    [maxHeight]="'100px'"
    [textColor]="'var(--white)'"
    [type]="'warning'"
    [canClose]="false"
    [animation]="true"
    [hasBreadCrumb]="selectedPayment"
  ></gc-note-banner>
}
<div class="body" *ngIf="!selectedPayment" [@slideOutIn]>
  <!-- Filter for mobile -->
  <div
    class="filter filter-mobile"
    [class.search-mode]="searchMode"
    *ngIf="display.isMobile$ | async"
    matSort
    matSortDisableClear="true"
    matSortActive="invoiceDate"
    matSortDirection="desc"
  >
    <div class="search">
      <mat-icon svgIcon="magnify" class="magnifier" (click)="searchMode = true"></mat-icon>
      <input gcAutofocus type="text" name="search" placeholder="{{ 'search_payments' | translate }}" [formControl]="searchControl" />
      <mat-icon svgIcon="close" class="close-search" (click)="searchMode = false"></mat-icon>
    </div>
    <gc-type-filter minimal="true" [data]="_payments" (filterCallback)="onFilter($event)" [types]="typeFilters"></gc-type-filter>
    <p mat-sort-header="invoiceDate" mat-sort-start="desc">{{ 'date' | translate }}</p>
  </div>
  <!-- Filter for desktop -->
  <div class="hide-on-mobile filter">
    <div class="filter-header">
      <gc-search-input [formControl]="searchControl" placeholder="{{ 'search_payments' | translate }}"></gc-search-input>
      <h2 class="heading-1">{{ 'filter' | translate }}</h2>
    </div>
    <gc-type-filter #typeFilter [data]="_payments" (filterCallback)="onFilter($event)" [types]="typeFilters"></gc-type-filter>
  </div>
  <div class="payments-container">
    <div class="payments">
      <ng-container
        *ngIf="(display.isMobile$ | async) === false"
        matSort
        matSortDisableClear="true"
        matSortActive="invoiceDate"
        matSortDirection="desc"
      >
        <p mat-sort-header="invoiceDate" mat-sort-start="desc" class="hide-on-mobile">{{ 'date' | translate }}</p>
      </ng-container>
      <mat-accordion class="payments-accordion" hideToggle="true" *ngFor="let payment of payments$ | async; let i = index">
        <mat-expansion-panel
          [expanded]="step === i"
          (opened)="setStep(i)"
          [disabled]="(display.isMobile$ | async) === false"
          class="payments-expansion-panel"
        >
          <mat-expansion-panel-header class="payments-expansion-header">
            <span class="payments-expansion-row text-style">
              <mat-icon [color]="payment.paid ? 'accent' : 'warn'">
                {{ payment.paid ? 'check_circle' : 'error_outline' }}
              </mat-icon>
              <span>
                <span class="date">{{ payment.invoiceDate | customDate: 'd MMMM y, HH:mm' }}</span>
                <br />
                <span class="description" [class.error]="!payment.paid">
                  {{ payment.paymentAmount | currency: (currencyCode$ | async) : 'symbol-narrow' }} - {{ payment.treatingDoctor }}
                </span>
              </span>
              <button
                *ngIf="payment.paid"
                mat-flat-button
                (click)="onDownload(payment)"
                color="accent"
                type="button"
                class="hide-on-mobile"
              >
                {{ 'download_summary_of_payments' | translate }}
              </button>
              <button
                mat-flat-button
                (click)="selectPayment(payment, $event)"
                [color]="payment.paid ? 'accent' : 'primary'"
                type="button"
                class="hide-on-mobile"
              >
                {{ payment.paid ? ('view_invoice' | translate) : ('pay_now' | translate) }}
              </button>
            </span>
          </mat-expansion-panel-header>
          <mat-panel-description class="invoice-details">
            <span class="extra">
              <b>{{ 'account_number' | translate }}:</b>
              {{ payment.accountNumber }}
            </span>
            <span class="extra">
              <b>{{ 'invoice_date' | translate }}:</b>
              {{ payment.invoiceDate | customDate: 'd MMMM y, HH:mm' }}
            </span>
            <span class="extra">
              <b>{{ 'doctor' | translate }}:</b>
              {{ payment.treatingDoctor }}
            </span>
            <span class="extra" *ngIf="payment.invoices">
              <b>{{ 'number_of_invoices' | translate }}:</b>
              {{ payment.invoices.length }}
            </span>
          </mat-panel-description>
          <mat-action-row class="actions">
            <button
              mat-flat-button
              (click)="selectPayment(payment, $event)"
              [color]="payment.paid ? 'accent' : 'primary'"
              type="button"
              class="pay-now-mobile"
            >
              {{ payment.paid ? ('view_invoice' | translate) : ('pay_now' | translate) }}
            </button>
            <button mat-flat-button class="hide-on-mobile nav-buttons" (click)="prevStep()">{{ 'previous' | translate }}</button>
            <button mat-flat-button class="hide-on-mobile nav-buttons" (click)="nextStep()">{{ 'next' | translate }}</button>
          </mat-action-row>
        </mat-expansion-panel>
      </mat-accordion>
    </div>
    <mat-paginator class="bottom" [pageSizeOptions]="[10, 20, 100]"></mat-paginator>
  </div>
</div>
<div>
  <gc-breadcrumb-bar
    class="header"
    *ngIf="selectedPayment"
    [@slideInOut]
    [crumbs]="['payments' | translate, 'make_payment' | translate]"
    [defaultBackFunction]="false"
    (backEvent)="backPayment()"
    (selectEvent)="backPayment()"
  ></gc-breadcrumb-bar>
  <div class="view-payment">
    <gc-view-payment [payment]="selectedPayment" url="/payments"></gc-view-payment>
  </div>
</div>
